import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Grid, Link, List, ListItem, Paper, Tab, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { ASL_3, ASL_5 } from "../../global/multiAsl";
import { contattiAsl } from "../../global/informazioniContatti";

export const Contatti = () => {

    const [value, setValue] = useState(ASL_3.codice);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    useEffect(() => {
        window.scroll(0, 0)
    }, [])

    const ContattiInformazioniLayout = ({ contatti }) => {
        return (
            <Grid container wrap="nowrap" spacing={2}>
                <Grid item xs zeroMinWidth>
                    <Typography component='h2'
                        sx={{
                            color: "#005397",
                            justifyContent: "left",
                            fontSize: { xs: "25px", md: "40px" },
                        }}>
                        Contatti
                    </Typography>
                    <Typography
                        sx={{
                            mt: "20px",
                            fontSize: { xs: "15px", md: "20px" },
                        }}>
                        {contatti?.contatti}
                    </Typography>

                    <Typography component='h2'
                        sx={{
                            color: "#005397",
                            justifyContent: "flex-start",
                            paddingTop: "4vh",
                            fontSize: { xs: "25px", md: "40px" },
                        }}>
                        Informazioni
                    </Typography>
                    <Paper
                        elevation={6}
                        sx={{
                            minHeight: "150px",
                            borderRadius: "20px",
                            textDecoration: "none !important",
                            display: "flex",
                            width: "100%",
                            padding: "0px",
                            flexDirection: 'column',
                            mt: "30px",
                        }}
                    >
                        <Typography component='span'
                            sx={{
                                justifyContent: "flex-start",
                                margin: "auto 20px",
                                mt: "30px",
                                mb: "30px",
                                fontSize: { xs: "15px", md: "20px" },
                            }}>
                            {contatti?.informazioni?.intro}
                            <List sx={{ listStyle: "disc", pl: 4 }}>
                                {contatti?.informazioni?.list?.map((info, index) => {
                                    return (
                                        <ListItem key={index} sx={{ display: "list-item" }}>
                                            {info?.pretext}
                                            {info?.link &&
                                                <Link sx={{ fontSize: { xs: "15px", md: "20px" }, wordBreak: "break-word", "&:hover": { textDecoration: 'underline' } }}
                                                    target="_blank" rel="noreferrer" href={info?.link} title={info?.link}>{info?.linkTitle}</Link>}
                                            {info?.postText}
                                        </ListItem>
                                    )
                                })}
                            </List>
                        </Typography>
                    </Paper>
                </Grid>
            </Grid>
        )
    }

    return (
        <>
            <Box
                className="emptyBg"
                sx={{
                    flexGrow: 1,
                    overflow: 'hidden',
                    with: "100%"
                }}>

                <Box sx={{ x: 'auto' }}>
                    <Grid container wrap="nowrap" >
                        <Grid item xs zeroMinWidth>

                            <Box sx={{ width: "100%", height: "150px", display: "flex" }}>
                                <Typography
                                    component='h1'
                                    sx={{
                                        color: "#005397",
                                        margin: "auto",
                                        textAlign: "center",
                                        fontSize: { xs: "25px", md: "40px" },
                                        fontWeight: 700,
                                    }}
                                >
                                    Contatti e Informazioni
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>

                <Box sx={{ my: 0, mx: 'auto', paddingBottom: "20vh" }}>
                    <Grid container wrap="nowrap" spacing={2}>
                        <Grid item> </Grid>
                        <Grid item xs zeroMinWidth>
                            <Box
                                sx={{
                                    width: "80%",
                                    margin: "auto",
                                    display: "flex",
                                    flexDirection: "column",
                                }}
                            >
                                <Box sx={{ width: '100%', display: "flex", justifyContent: 'center' }}>
                                    <TabContext value={value} >
                                        <Box sx={{ display: "flex", justifyContent: 'center', flexDirection: 'column' }}>
                                            <Box sx={{ display: "flex", justifyContent: 'center', }}>
                                                <TabList onChange={handleChange} aria-label="Tabs enti">
                                                    <Tab label="Asl 3" value={ASL_3.codice} disableRipple sx={{ fontSize: { xs: '16px', md: '30px' }, fontWeight: 600, color: "#005397" }} />
                                                    <Tab label="Asl 5" value={ASL_5.codice} disableRipple sx={{ fontSize: { xs: '16px', md: '30px' }, fontWeight: 600, color: "#005397" }} />
                                                </TabList>
                                            </Box>
                                            <Box sx={{ width: '100%' }}>
                                                <TabPanel value={ASL_3.codice}>
                                                    <ContattiInformazioniLayout contatti={contattiAsl?.asl3} />
                                                </TabPanel>
                                                <TabPanel value={ASL_5.codice}>
                                                    <ContattiInformazioniLayout contatti={contattiAsl?.asl5} />
                                                </TabPanel>
                                            </Box>
                                        </Box>
                                    </TabContext>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>

            </Box>
        </>
    );
}